export const gendor = [
  {
    label: '男',
    value: 1
  },
  {
    label: '女',
    value: 2
  }
]
// export const combo = [
//   {
//     label: '试用期',
//     value: 1
//   },
//   {
//     label: '专业包月版',
//     value: 2
//   },
//   {
//     label: '专业包年版',
//     value: 3
//   },
// ]
export const accountStatus = [
  {
    label: '试用',
    value: 1
  },
  {
    label: '正式',
    value: 2
  },
  {
    label: '过期',
    value: 3
  }
]
export const intention = [
  {
    label: '一般',
    value: 1
  },
  {
    label: '强烈',
    value: 2
  },
  {
    label: '非常强烈',
    value: 3
  }
]
export const collectionsFilterObj = [
  {
    label: '商品名称',
    value: 1
  },
  {
    label: '商品类目',
    value: 2
  },
  {
    label: '商品库存',
    value: 3
  }
]

export const collectionsSortType = [
  {
    label: '畅销降序',
    value: 1
  },
  {
    label: '点击率降序',
    value: 2
  },
  {
    label: '时间降序',
    value: 3
  }
]
// 1:包含;2:不包含;3:等于;4:不等于;5:开头为;6:结尾为;7:大于;8:等于;9:小于
export const collectionsFilterType = [
  {
    label: '包含',
    value: 1
  },
  {
    label: '不包含',
    value: 2
  },
  {
    label: '等于',
    value: 3
  },
  {
    label: '不等于',
    value: 4
  },
  {
    label: '开头为',
    value: 5
  },
  {
    label: '结尾为',
    value: 6
  },
  {
    label: '大于',
    value: 7
  },
  {
    label: '等于',
    value: 8
  },
  {
    label: '小于',
    value: 9
  }
]

export const timeSort = [
  {
    id: 0,
    label: '全部',
    value: ''
  },
  {
    id: 1,
    label: '按上架时间顺序：旧->新',
    value: 2
  },
  {
    id: 2,
    label: '按上架时间倒序：新->旧',
    value: 1
  }
]

export const commentsSort = [
  {
    id: 0,
    label: '全部',
    value: ''
  },
  {
    id: 1,
    label: '无评论',
    value: 1
  },
  {
    id: 2,
    label: '有评论',
    value: 2
  }
]

export const isFrontShow = [
  {
    id: 0,
    label: '全部',
    value: ''
  },
  {
    id: 1,
    label: '未展示在商详页',
    value: 1
  },
  {
    id: 2,
    label: '展示在商详页',
    value: 2
  }
]

export const moveTypeList = [
  {
    label: '顶部',
    value: 1
  },
  {
    label: '底部',
    value: 2
  },
  {
    label: '指定位置',
    value: 3
  }
]

export const productSearchType = [
  {
    label: '商品名称',
    value: 1
  },
  {
    label: 'SpuId',
    value: 2
  }
]

export const generalPageName = ['authority', 'error_404', 'expired', 'account', 'site-create', 'layout', 'domain', 'system-control', 'message-center', 'index', 'login',
  'personal-board-setting', 'board-center-setting', 'data-board', 'iframe-board', 'open-contract', 'my-contract', 'my-account', 'my-message', 'ad-analysis', 'customer-profits',
  'day-report', 'month-report', 'screen-board', 'sc-analysis', 'order-link', 'personal-turn', 'sale-area', 'stocks-analysis', 'subscribe', 'order-analysis', 'performance-board',
  'merits-board', 'merits-board-detail', 'enterprise-manager', 'paypal-monitor', 'month-profits']
export const noContractPage = ['expired', 'account', 'site-create', 'layout', 'domain', 'open-contract', 'my-contract', 'my-account', 'my-message', 'personal-turn', 'subscribe']
export const personalPage = ['/open-contract', '/my-contract', '/my-account', '/my-message', '/personal-turn', '/subscribe']

export const shopTypeList = [
  { label: 'Shoplus', value: 1 },
  { label: 'Shopify', value: 2 },
  { label: 'Shoplazza', value: 3 },
  { label: 'Shopline', value: 4 },
  { label: 'Shopbase', value: 5 }
]
